/* Cart Label & Price Styling v3 - Kingbriefs */
;(function() {
  'use strict';

  var PILL = {
    monthly:   'display:inline-block;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:600;letter-spacing:0.03em;background:#5B9BD5;color:#fff;',
    quarterly: 'display:inline-block;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:600;letter-spacing:0.03em;background:#2E75B6;color:#fff;',
    annual:    'display:inline-block;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:600;letter-spacing:0.03em;background:#1B4F8A;color:#fff;',
    bundle:    'display:inline-block;padding:3px 10px;border-radius:20px;font-size:11px;font-weight:600;letter-spacing:0.03em;background:#2d6b4f;color:#fff;'
  };
  var DESC_S = 'display:block;font-size:11px;color:#888;margin-top:3px;font-weight:400;font-style:normal;';

  function styleLabels() {
    try {
      var selectors = '.cart-item__plan, .cart-item__discounts span, .cart-item__discounts li';
      document.querySelectorAll(selectors).forEach(function(el) {
        if (el.dataset.kbF) return;
        var txt = (el.textContent || '').trim();

        if (/^Bundle\s*&\s*Save$/i.test(txt)) {
          el.innerHTML = '<span style="' + PILL.bundle + '">BUNDLE \u00B7 SAVE</span>';
          el.dataset.kbF = '1';
        } else if (/^Annual\s*Prepaid/i.test(txt)) {
          var d = txt.match(/\(([^)]+)\)/);
          el.innerHTML = '<span style="' + PILL.annual + '">ANNUAL PREPAID</span><span style="' + DESC_S + '">' + (d ? d[1] : '12 pairs, 3 pairs every 3 months') + '</span>';
          el.dataset.kbF = '1';
        } else if (/^Monthly\s*(\(|Sub)/i.test(txt)) {
          var d2 = txt.match(/\(([^)]+)\)/);
          el.innerHTML = '<span style="' + PILL.monthly + '">MONTHLY</span><span style="' + DESC_S + '">' + (d2 ? d2[1] : '1 pair every month') + '</span>';
          el.dataset.kbF = '1';
        } else if (/^Quarterly\s*(\(|Sub)/i.test(txt)) {
          var d3 = txt.match(/\(([^)]+)\)/);
          el.innerHTML = '<span style="' + PILL.quarterly + '">QUARTERLY</span><span style="' + DESC_S + '">' + (d3 ? d3[1] : '3 pairs every 3 months') + '</span>';
          el.dataset.kbF = '1';
        }
      });

      document.querySelectorAll('.cart-item__plan').forEach(function(plan) {
        if (plan.dataset.kbF) return;
        var spans = plan.querySelectorAll('span');
        if (spans.length >= 1) {
          var nameSpan = spans[0];
          var txt2 = nameSpan.textContent.trim();
          var style = txt2 === 'ANNUAL PREPAID' ? PILL.annual :
                      txt2 === 'MONTHLY' ? PILL.monthly :
                      txt2 === 'QUARTERLY' ? PILL.quarterly : null;
          if (style && !nameSpan.dataset.kbF) {
            nameSpan.style.cssText = style;
            nameSpan.dataset.kbF = '1';
          }
        }
      });
    } catch(e) {}
  }

  function stylePrices() {
    try {
      document.querySelectorAll('.cart-item, drawer-cart-item').forEach(function(item) {
        var plan = item.querySelector('.cart-item__plan');
        if (!plan) return;
        var planText = plan.textContent.trim();
        var isMonthly = /MONTHLY|Monthly/i.test(planText);
        var isQuarterly = /QUARTERLY|Quarterly/i.test(planText);

        /* Process mini cart price area + cart page TOTAL column */
        var priceAreas = item.querySelectorAll('.cart-item__actions--price, .cart-item__total-price');
        priceAreas.forEach(function(priceArea) {
          var existingDiscount = priceArea.querySelector('.cart-item__discounted-prices');
          if (existingDiscount) {
            var saleEl = existingDiscount.querySelector('ins, span:first-child, .cart-item__final-price');
            if (saleEl && saleEl.tagName !== 'S' && saleEl.tagName !== 'DEL') {
              saleEl.style.color = 'rgb(204,0,0)';
              saleEl.style.fontWeight = '700';
              saleEl.style.textDecoration = 'none';
            }
            return;
          }

          if (!isMonthly && !isQuarterly) return;
          var priceSpan = priceArea.querySelector('span.cart-item__price, .cart-item__price, .price.price--end, .price, span:not(.visually-hidden)');
          if (!priceSpan || priceSpan.dataset.kbP) return;
          var match = priceSpan.textContent.trim().match(/\$([\d.]+)/);
          if (!match) return;
          var salePrice = parseFloat(match[1]);
          var origPrice = isMonthly ? salePrice / 0.95 : salePrice / 0.82;

          priceSpan.dataset.kbP = '1';
          priceSpan.outerHTML = '<div class="cart-item__discounted-prices cart-item__price" style="display:flex;flex-direction:column;align-items:flex-end;">' +
            '<ins style="color:rgb(204,0,0);font-weight:700;text-decoration:none;">$' + salePrice.toFixed(2) + '</ins>' +
            '<del style="color:#999;font-weight:400;">$' + origPrice.toFixed(2) + '</del></div>';
        });
      });
    } catch(e) {}
  }

  function process() {
    styleLabels();
    stylePrices();
  }

  var debounceTimer;
  function debouncedProcess() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(process, 300);
  }

  new MutationObserver(debouncedProcess).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', process);
  } else {
    process();
  }
  setTimeout(process, 1000);
  setTimeout(process, 3000);
})();

/* ======== Cart Savings Display (isolated IIFE) ======== */
;(function() {
  'use strict';

  var SAVINGS_ID = 'kb-cart-savings';

  function calculateSavings() {
    try {
      var totalOriginal = 0;
      var totalSale = 0;

      document.querySelectorAll('.cart-item, drawer-cart-item').forEach(function(item) {
        /* Get quantity */
        var qtyInput = item.querySelector('input[name="updates[]"], input.quantity__input, input[type="number"]');
        var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

        /* Find original (compare-at) price and sale price per unit */
        var oldPriceEl = item.querySelector('s, del, .cart-item__old-price, .cart-item__compare-at-price');
        var salePriceEl = item.querySelector('ins, .cart-item__final-price, .cart-item__discounted-prices span:first-child');

        if (oldPriceEl && salePriceEl) {
          var oldMatch = oldPriceEl.textContent.match(/\$([\d.]+)/);
          var saleMatch = salePriceEl.textContent.match(/\$([\d.]+)/);
          if (oldMatch && saleMatch) {
            totalOriginal += parseFloat(oldMatch[1]) * qty;
            totalSale += parseFloat(saleMatch[1]) * qty;
            return;
          }
        }

        /* For items with line total (right side price) */
        var linePrices = item.querySelectorAll('.cart-item__actions--price s, .cart-item__actions--price del');
        var lineSale = item.querySelectorAll('.cart-item__actions--price ins, .cart-item__actions--price .cart-item__final-price');
        if (linePrices.length && lineSale.length) {
          var lpMatch = linePrices[0].textContent.match(/\$([\d.]+)/);
          var lsMatch = lineSale[0].textContent.match(/\$([\d.]+)/);
          if (lpMatch && lsMatch) {
            totalOriginal += parseFloat(lpMatch[1]);
            totalSale += parseFloat(lsMatch[1]);
            return;
          }
        }

        /* No discount - just add sale price */
        var anyPrice = item.querySelector('.cart-item__price, .price');
        if (anyPrice) {
          var m = anyPrice.textContent.match(/\$([\d.]+)/);
          if (m) {
            var p = parseFloat(m[1]);
            totalOriginal += p * qty;
            totalSale += p * qty;
          }
        }
      });

      return { original: totalOriginal, sale: totalSale, savings: totalOriginal - totalSale };
    } catch(e) {
      return { original: 0, sale: 0, savings: 0 };
    }
  }

  function injectSavings() {
    try {
      var data = calculateSavings();
      if (data.savings <= 0) {
        /* Remove existing savings display if no savings */
        var existing = document.querySelectorAll('.' + SAVINGS_ID);
        existing.forEach(function(el) { el.remove(); });
        return;
      }

      var savingsHTML = '<div class="' + SAVINGS_ID + '" style="text-align:right;margin-top:4px;font-size:13px;font-weight:600;color:#2d6b4f;">' +
        '\uD83C\uDF89 You\'re saving $' + data.savings.toFixed(2) + '!' +
        '</div>';

      /* Find subtotal areas (mini cart + cart page) */
      var subtotalEls = document.querySelectorAll(
        '.cart-drawer__footer .totals, ' +
        '.cart-drawer__footer .cart__subtotal, ' +
        '.cart__ctas .totals, ' +
        '.cart__footer .totals, ' +
        '[class*="cart"] .totals'
      );

      subtotalEls.forEach(function(el) {
        if (el.querySelector('.' + SAVINGS_ID)) return; /* already injected */
        el.insertAdjacentHTML('afterend', savingsHTML);
      });

      /* Also try cart page sidebar */
      var cartSubtotal = document.querySelector('.cart__subtotal, .totals__subtotal');
      if (cartSubtotal && !cartSubtotal.parentElement.querySelector('.' + SAVINGS_ID)) {
        cartSubtotal.insertAdjacentHTML('afterend', savingsHTML);
      }
    } catch(e) { /* safe */ }
  }

  var debounceTimer;
  function debouncedInject() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(injectSavings, 500);
  }

  new MutationObserver(debouncedInject).observe(document.body, { childList: true, subtree: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectSavings);
  } else {
    injectSavings();
  }
  setTimeout(injectSavings, 1500);
  setTimeout(injectSavings, 4000);
})();
